import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class LazyImage extends Component {
  constructor(props) {
    super(props);
    const { placeholder } = this.props;
    this.state = {
      imageLoadFinishedClass: '',
      placeholderStyle: {
        backgroundImage: `url(${
          placeholder || 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
        })`
      }
    };
  }

  imageLoadHandler = () => {
    this.setState({ imageLoadFinishedClass: 'lazyImage__fadeIn' });

    const { onLoad } = this.props;
    if (onLoad) onLoad();
  };

  render() {
    const { imageLoadFinishedClass, placeholderStyle } = this.state;
    const { className, alt, src, onError } = this.props;
    return (
      <div className={classnames('lazyImage__container', className)} style={placeholderStyle}>
        <img
          className={classnames('lazyImage', imageLoadFinishedClass)}
          alt={alt}
          src={src}
          onLoad={this.imageLoadHandler}
          onError={onError}
        />
      </div>
    );
  }
}

LazyImage.propTypes = {
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  onError: PropTypes.func,
  onLoad: PropTypes.func,
  placeholder: PropTypes.string,
  src: PropTypes.string.isRequired
};

LazyImage.defaultProps = {
  className: '',
  onError: null,
  onLoad: null,
  placeholder: null
};

export default LazyImage;
